module.exports = __webpack_public_path__ + "static/media/wortenIllustration.56bc97d7.svg";